<script setup lang="ts">
  import { useLegacyProjectStore } from '@/store/legacy-project.store'

  const projectStore = useLegacyProjectStore()
</script>

<template>
  <div v-if="projectStore.lastCreatedProjectStroomName().length > 0">
    <span>Laatst aangemaakte kenmerk: </span>
    <span class="last-created">{{ projectStore.lastCreatedProjectStroomName() }}</span>
  </div>
</template>

<style scoped>
  .last-created {
    font-weight: bold;
    color: var(--colours-brand-colour-1);
  }
</style>
